import { NavLink } from 'react-router-dom';
import { useAuth } from '../store/useAuth.js';
import { hasModule } from '../validation/roles.js';

/**
 * `module` is the permission each page needs. The dashboard and the account page
 * have none — everyone signed in can reach those.
 *
 * The filter here uses the same `hasModule` the server uses, so the sidebar can
 * never show a page the API would refuse, nor hide one it would serve.
 */
export const NAV = [
  { group: 'Overview', to: '/', label: 'Inventory Dashboard', end: true },
  { group: 'Catalog', to: '/products', label: 'Product Name', module: 'Product Name' },
  { group: 'Catalog', to: '/textures', label: 'Texture Management', module: 'Texture Management' },
  { group: 'Catalog', to: '/lengths', label: 'Length Management', module: 'Length Management' },
  { group: 'Catalog', to: '/colors', label: 'Color Management', module: 'Color Management' },
  { group: 'Parties', to: '/vendors', label: 'Vendor Management', module: 'Vendor Management' },
  { group: 'Parties', to: '/customers', label: 'Customer Management', module: 'Customer Management' },
  { group: 'Stock', to: '/stock-in', label: 'Stock In Management', module: 'Stock In Management' },
  { group: 'Stock', to: '/stock-out', label: 'Stock Out / Invoice', module: 'Stock Out / Invoice' },
  { group: 'Pricing', to: '/prices', label: 'Price Management', module: 'Price Management' },
  { group: 'Reports', to: '/reports/stock-status', label: 'Stock Status Report', module: 'Reports' },
  { group: 'Reports', to: '/reports/sales', label: 'Sales Report', module: 'Reports' },
  { group: 'Admin', to: '/users', label: 'User Management', module: 'User Management' },
  { group: 'Admin', to: '/account', label: 'My Account' },
];

export function navFor(user) {
  return NAV.filter((item) => !item.module || hasModule(user, item.module));
}

function groupNav(items) {
  const groups = [];
  for (const item of items) {
    let group = groups.find((g) => g.name === item.group);
    if (!group) {
      group = { name: item.group, items: [] };
      groups.push(group);
    }
    group.items.push(item);
  }
  return groups;
}

export default function Sidebar() {
  const { user } = useAuth();

  return (
    <nav className="sidebar" aria-label="Main">
      <div className="brand">
        <div className="brand-mark" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M4 6c3-4 7-4 10 0s3 8 6 8" stroke="#2A1420" strokeWidth="2.4" strokeLinecap="round" />
          </svg>
        </div>
        <div>
          <div className="brand-name">
            Vipin Hair
            <br />
            Extension
          </div>
          <div className="brand-sub">Inventory System</div>
        </div>
      </div>

      <div className="nav-scroll">
        {groupNav(navFor(user)).map((group) => (
          <div className="nav-group" key={group.name}>
            <div className="nav-group-label">{group.name}</div>
            {group.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
              >
                <span className="dot" aria-hidden="true" />
                {item.label}
              </NavLink>
            ))}
          </div>
        ))}
      </div>
    </nav>
  );
}
